import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  adminCombineSx,
  adminStatusPillSx,
  adminStatusPillToneSx,
  type AdminStatusPillTone,
} from '../../styles/adminComponentStyles';

type AdminStatusPillProps = {
  label: string;
  tone?: AdminStatusPillTone;
  sx?: SxProps<Theme>;
};

const AdminStatusPill: React.FC<AdminStatusPillProps> = ({ label, tone = 'neutral', sx }) => (
  <Box component="span" sx={adminCombineSx(adminStatusPillSx, adminStatusPillToneSx[tone], sx)}>
    {label}
  </Box>
);

export type { AdminStatusPillTone };
export default React.memo(AdminStatusPill);
